module.exports = __webpack_public_path__ + "static/media/drawing__frame.babbbf54.png";